var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"card"},[_c('h1',[_vm._v("Page Not Found")]),_c('v-btn',{staticClass:"primary",on:{"click":_vm.goHome}},[_vm._v("Go back to homepage")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }